import { useEffect, useRef } from "react";

export function usePrevious<V>(value: V): V {
  const ref = useRef<V>(null);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}
